import React, { useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebase/firebase';
import logo from '../assets/logo.png';
import './Navbar.css';

const Navbar = () => {
  const [user] = useAuthState(auth);
  const navigate = useNavigate();
  const isAdmin = user?.email === 'aubair245@gmail.com';
  const collapseRef = useRef(null);
  const bsCollapseRef = useRef(null);

  useEffect(() => {
    if (collapseRef.current) {
      const collapseEl = collapseRef.current;
      bsCollapseRef.current = new window.bootstrap.Collapse(collapseEl, {
        toggle: false,
      });

      // ✅ Close on outside click (mobile only)
      const handleClickOutside = (e) => {
        const isMenuOpen = collapseEl.classList.contains('show');
        const isClickInside = collapseEl.contains(e.target);
        const isToggler = e.target.closest('.navbar-toggler');

        if (isMenuOpen && !isClickInside && !isToggler) {
          bsCollapseRef.current.hide();
        }
      };

      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, []);

  const handleLogout = async () => {
    await auth.signOut();
    navigate('/login');
  };

  const toggleCollapse = () => {
    if (bsCollapseRef.current) {
      bsCollapseRef.current.toggle();
    }
  };

  const closeMenu = () => {
    if (bsCollapseRef.current && collapseRef.current.classList.contains('show')) {
      bsCollapseRef.current.hide();
    }
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm sticky-top">
        <div className="container-fluid px-2">
          {/* Brand */}
          <Link className="navbar-brand d-flex align-items-center" to="/" onClick={closeMenu}>
            <img src={logo} alt="Logo" className="navbar-logo" />
            <span className="fw-bold text-primary">Kashmir Jobs</span>
          </Link>

          {/* Toggler */}
          <button className="navbar-toggler" type="button" onClick={toggleCollapse}>
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Collapsible Nav */}
          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarNav"
            ref={collapseRef}
          >
            <ul className="navbar-nav align-items-center flex-wrap">
              <li className="nav-item">
                <Link className="nav-link" to="/" onClick={closeMenu}>Home</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/jobs" onClick={closeMenu}>Jobs</Link>
              </li>
             
             {!isAdmin && (
  <li className="nav-item">
    <Link className="nav-link" to="/contact" onClick={closeMenu}>Contact Us</Link>
  </li>
)}

              <li className="nav-item">
                <Link className="nav-link" to="/post-job" onClick={closeMenu}>Post a Job</Link>
              </li>
              {isAdmin && (
                <li className="nav-item">
                  <Link className="nav-link fw-bold text-danger" to="/admin" onClick={closeMenu}>
                    Admin Panel
                  </Link>
                </li>
              )}
              {user && (
                <li className="nav-item">
                  <Link className="nav-link" to="/profile" onClick={closeMenu}>My Profile</Link>
                </li>
              )}
              {!user ? (
                <>
                  <li className="nav-item">
                    <Link className="nav-link" to="/register" onClick={closeMenu}>Register</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/login" onClick={closeMenu}>Login</Link>
                  </li>
                </>
              ) : (
                <li className="nav-item">
                  <button
                    className="btn btn-sm logout-btn ms-2"
                    onClick={() => {
                      handleLogout();
                      closeMenu();
                    }}
                  >
                    Logout
                  </button>
                </li>
              )}

              {/* ✅ Close Menu button at bottom (mobile only) */}
              <li className="nav-item d-lg-none">
                <button className="btn btn-sm close-menu-btn" onClick={closeMenu}>
                  Close Menu
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* 🔵 Blue Strip Below Navbar */}
      <div className="navbar-blue-strip" />
    </>
  );
};

export default Navbar;
